import React from 'react';
import { PrimaryHeader } from 'Components/Display';

export const UserManagementHeader: React.FC = () => {
  return <PrimaryHeader title="User Management" />
}